import { render } from "./App.vue?vue&type=template&id=0bc16493&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0bc16493&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0bc16493"

export default script